// Auto-generated per-query builders for DerivedValue
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { DerivedValueReadAPI, DerivedValueWriteAPI, DerivedValueReadAPISchema, DerivedValueWriteAPISchema } from '../types/derivedvalue';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, DerivedValueOfAttribute, DerivedValueOfExpression, HasDerivedValue } from '../../relationships/relationship';

import { RFLPElement } from './rflpelement';
import { Attribute } from './attribute';
import { DerivedExpression } from './derivedexpression';
import { SecurityScope } from '../../shared/api/securityscope';





// Builder chain for query: rflp-derived-value-by-id

export interface RflpDerivedValueByIdBuilder_0 {
  get(id: string): RflpDerivedValueByIdBuilder_1;
  filter(conditions: { id: string }): RflpDerivedValueByIdBuilder_1;
}

export interface RflpDerivedValueByIdBuilder_1 {
  all(): Promise<DerivedValue[]>;
  first(): Promise<DerivedValue | null>;
  get(): Promise<DerivedValue[]>;
  execute(): Promise<DerivedValue[]>;
}


// Union of all query entry points
export type DerivedValueQueryBuilder = RflpDerivedValueByIdBuilder_0;

// Available query names for .setQuery()
export type DerivedValueQueryNames = "rflp-derived-value-by-id";

// Type narrowing for .setQuery()
export type DerivedValueBuilderForQuery<Q extends DerivedValueQueryNames> =
  Q extends "rflp-derived-value-by-id" ? RflpDerivedValueByIdBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type DerivedValueInstanceQueryResult<Q extends DerivedValueQueryNames> =
  Q extends "rflp-derived-value-by-id" ? RflpDerivedValueByIdBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'rflp-derived-value-by-id',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends DerivedValueQueryNames>(queryName: Q): DerivedValueBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}


export interface DerivedValue extends Partial<DerivedValueReadAPI> {}
export class DerivedValue extends NeoNodeBase<DerivedValueReadAPI, DerivedValueWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "DerivedValue";
  static readonly readSchema = DerivedValueReadAPISchema;
  static readonly writeSchema = DerivedValueWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    owner: { target: "RFLPElement", cardinality: "one", isParent: true, relClass: "HasDerivedValue", direction: "in" },
    attribute: { target: "Attribute", cardinality: "one", isParent: true, relClass: "DerivedValueOfAttribute", direction: "out" },
    expression: { target: "DerivedExpression", cardinality: "one", isParent: true, relClass: "DerivedValueOfExpression", direction: "out" },
  };

  protected get modelName(): string {
    return 'DerivedValue';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return DerivedValue.label;
  }


  constructor(data: Partial<DerivedValueWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: DerivedValueReadAPI, loadContext?: Record<string, any>): DerivedValue {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { owner, attribute, expression, security_scope, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = DerivedValueReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, owner: owner, attribute: attribute, expression: expression, security_scope: security_scope };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return DerivedValue.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadManyRelationship(processed, 'owner', 'RFLPElement', ModelRegistry);
    loadOneRelationship(processed, 'attribute', 'Attribute', ModelRegistry);
    loadOneRelationship(processed, 'expression', 'DerivedExpression', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new DerivedValue(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): DerivedValueQueryBuilder {
    return new QueryBuilderImpl('DerivedValue').filter(conditions) as any;
  }

  static all(): DerivedValueQueryBuilder {
    return new QueryBuilderImpl('DerivedValue') as any;
  }

  static async first(): Promise<DerivedValue | null> {
    const results = await new QueryBuilderImpl('DerivedValue').execute();
    return results[0] || null;
  }


  static setQuery<Q extends DerivedValueQueryNames>(queryName: Q): DerivedValueBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('DerivedValue');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends DerivedValueQueryNames>(queryName: Q): DerivedValueInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = DerivedValue.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  // Relationship manager for 'owner' - Python ORM style (cached)
  get owner(): RelationshipManager<this, RFLPElement> {
    return this.getOrCreateRelationshipManager('owner', () => {
      return new RelationshipManager(this, 'owner', 'one', HasDerivedValue as typeof Relationship);
    });
  }

  // Relationship manager for 'attribute' - Python ORM style (cached)
  get attribute(): RelationshipManager<this, Attribute> {
    return this.getOrCreateRelationshipManager('attribute', () => {
      return new RelationshipManager(this, 'attribute', 'one', DerivedValueOfAttribute as typeof Relationship);
    });
  }

  // Relationship manager for 'expression' - Python ORM style (cached)
  get expression(): RelationshipManager<this, DerivedExpression> {
    return this.getOrCreateRelationshipManager('expression', () => {
      return new RelationshipManager(this, 'expression', 'one', DerivedValueOfExpression as typeof Relationship);
    });
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

}
